<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close" :close-on-click-modal="false">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">
      <el-form-item label="云平台" prop="cloud">
        <el-select v-model="initForm.cloud" placeholder="请选择云平台">
        <el-option
          v-for="cloud in cloudEnvList"
          :label="cloud"
          :key="cloud"
          :value="cloud"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="API名称" prop="name">
        <el-input v-model="initForm.name" placeholder="请输入API名称"></el-input>
      </el-form-item>

      <el-form-item label="API地址" prop="url">
        <el-input v-model="initForm.url" placeholder="API地址"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    initForm: {},
    updateType: {},
    cloudEnvList: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        cloud: [{required: true, message: "请输入云平台名称(英文简写)", trigger: "blur"}],
        name: [{required: true, message: "请输入API名称", trigger: "blur"}],
        url: [{required: true, message: "请输入API地址", trigger: "blur"}]
      },
      titles: {
        add: "新增",
        edit: "编辑"
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              cloud: this.initForm.cloud,
              name: this.initForm.name,
              url: this.initForm.url
        };
        if (!valid) {
          alert("请检查输入是否正确！");
          return false;
        }
        this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "sre-api/url/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "sre-api/url/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
